<div class="print-page flex flex-col min-h-[100vh] bg-white text-black p-6">

  <!-- HEADER -->
  <div class="border-b pb-2 mb-4">


    <div class="flex flex-row items-center justify-between gap-4">
            <div>
                <span class="block md:text-[15px] mb-[15px] md:mb-[25px]">
                    Invoice Number:
                    <span class="text-black dark:text-white">
                        #1346
                    </span>
                </span>
                <span class="block mb-[4px] md:text-[15px]">
                    Invoice To:
                </span>
                <span class="block mb-[4px] md:text-[15px] text-black dark:text-white">
                    Shannon Nelson
                </span>
                <span class="block mb-[4px] md:text-[15px] text-black dark:text-white">
                    4545 Seth Street Ballinger, TX 78965
                </span>
                <span class="block mb-[4px] md:text-[15px] text-black dark:text-white">
                    +1 444 556 8899
                </span>
            </div>
            <div class="my-[20px] md:my-0">
                <img src="images/logo_loomisFx.png" alt="qr-code-image" class="w-[120px]">
            </div>
            <div class="ltr:md:text-right rtl:md:text-left print:text-right">
                <span class="block md:text-[15px] mb-[15px] md:mb-[25px]">
                    Date:
                    <span class="text-black dark:text-white">
                        01 Dec 2025
                    </span>
                </span>
                <span class="block mb-[4px] md:text-[15px]">
                    Pay To:
                </span>
                <span class="block mb-[4px] md:text-[15px] text-black dark:text-white">
                    Mercedes Foreman
                </span>
                <span class="block mb-[4px] md:text-[15px] text-black dark:text-white">
                    458 Friendship Lane Walnut Creek, CA 5828
                </span>
                <span class="block mb-[4px] md:text-[15px] text-black dark:text-white">
                    +1 444 888 0055
                </span>
            </div>
        </div>

  </div>

  <!-- CONTENT prend toute la place -->
  <div class="flex-1">
    <order-purchase-summary></order-purchase-summary>
  </div>

  <!-- FOOTER en bas -->
  <div class="border-t pt-2 mt-4 text-sm text-gray-500">
    FOOTER
  </div>

</div>


